<template>
    <div class="e-invoicing-button">
        <button
            class="e-invoicing-button__button typographies-paragraph-small-semibold"
            data-bot="top-bar__button--FE"
            @click="$emit('click')"
        >
            <SassIcon icon="EInvoicing" :height="16" :width="16" />
            <span class="e-invoicing-button__label">{{ $t.__('common.labels.einvoicing') }}</span>
        </button>
    </div>
</template>
<script>
import SassIcon from 'vcomponents/common/SaasIcon.vue';
export default {
    components: {
        SassIcon,
    },
    emits: ['click'],
};
</script>
<style lang="scss" scoped>
.e-invoicing-button {
    border-radius: var(--spacing-0);
    margin: 0 var(--spacing-2) 0 0;
    padding: 1px;
    position: relative;
    z-index: 1;

    @media screen and (max-width: 1399px) {
        border-radius: 50%;
    }

    &:before,
    &::after {
        content: '';
        background: linear-gradient(
            90deg,
            var(--colors-sellsy-red-400) 0%,
            var(--colors-sellsy-brand-secondary-pink) 100%
        );
        border-radius: var(--spacing-0);
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        z-index: -1;
        clip-path: polygon(
            0% 100%,
            2px 100%,
            2px 2px,
            calc(100% - 2px) 2px,
            calc(100% - 2px) calc(100% - 2px),
            2px calc(100% - 2px),
            2px 100%,
            100% 100%,
            100% 0%,
            0% 0%
        );

        @media screen and (max-width: 1399px) {
            border-radius: 50%;
            clip-path: circle(50%);
        }
    }

    &:before {
        animation: pulse 10s ease-in-out infinite;

        @media screen and (max-width: 1399px) {
            animation-name: pulseCircle;
        }
    }

    &:after {
        opacity: 0;
        transition: opacity 200ms linear;
    }

    &:hover {
        &:after {
            opacity: 1;
        }
    }

    &__button {
        align-items: center;
        background: var(--colors-component-background-illustration-brand-secondary-grey);
        border: 0;
        border-radius: var(--spacing-0);
        color: var(--colors-common-text-brand-secondary-blue);
        cursor: pointer;
        display: flex;
        gap: var(--spacing-0);
        padding: var(--spacing-0) var(--spacing-1);
        transition-property: color, background-color, border-color;
        transition-duration: 100ms;
        transition-timing-function: cubic-bezier(0, 0, 0.3, 1);

        @media screen and (max-width: 1399px) {
            border-radius: 50%;
            gap: 0;
            height: var(--spacing-5);
            width: var(--spacing-5);
        }

        &:hover {
            background: var(--colors-common-background-primary-subtle);
        }
    }

    &__label {
        @media screen and (max-width: 1399px) {
            text-indent: -9999px;
        }
    }
}

@keyframes pulse {
    0%,
    80% {
        opacity: 0;
        transform: scale(1);
    }
    83% {
        opacity: 1;
        transform: scale(1);
    }
    95%,
    100% {
        opacity: 0;
        transform: scale3d(1.1, 1.5, 1);
    }
}

@keyframes pulseCircle {
    0%,
    80% {
        opacity: 0;
        transform: scale(1);
    }
    83% {
        opacity: 1;
        transform: scale(1);
    }
    95%,
    100% {
        opacity: 0;
        transform: scale(1.2);
    }
}
</style>
